import { InjectionToken } from '@angular/core';

// Los specs fijan la fecha en vez de depender del día en que corren; y el proyecto no usa `new Date()` suelto.
export const CLOCK = new InjectionToken<() => Date>('CLOCK', {
  providedIn: 'root',
  factory: () => () => new Date(),
});
